// extracted by mini-css-extract-plugin
export default {"person":"Person_person__Pmge2","personHeader":"Person_personHeader__h3iIE","personFilter":"Person_personFilter__U5If6"};